<template>
	<el-breadcrumb class="main-bread" separator-class="el-icon-arrow-right">
		<!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
		<!-- <el-breadcrumb-item v-if="name1">{{name1}}</el-breadcrumb-item> -->
		<el-breadcrumb-item v-if="name2">{{name2}}</el-breadcrumb-item>
		<!-- <el-breadcrumb-item v-if="name3">{{name3}}</el-breadcrumb-item> -->
	</el-breadcrumb>
</template>

<script>
	export default {
		data() {
			return {
				name1: '',
				name2: '',
				// name3:""
			}
		},
		watch: {
			'$route'() {
				// this.name1 = this.$route.meta.parentTitle
				this.name2 = this.$route.meta.title
				// this.name3 = this.$route.meta.title1
			}
		},
		mounted() {
			// this.name1 = this.$route.meta.parentTitle
			this.name2 = this.$route.meta.title
			// this.name3 = this.$route.meta.title1
		},
		
	}
</script>

<style scoped="scoped">
	.main-bread{
		height:50px;
		line-height: 50px;
		margin-bottom:20px;
		border-bottom: 1px solid #eee;
	}
	

</style>
